// src/images/RelicVault/badges/index.js
//
// Badge artwork, resized to 256px from the originals in "Quiklearn Badges".
// Only badges that have been designed appear here; getBadgeImage returns null
// for the rest and the UI shows a locked placeholder. Drop a new <id>.png in
// this folder and add a line below as each badge is finished.

/* eslint-disable global-require */

export const BADGE_IMAGES = {
  'ACC-001': require('./ACC-001.png'),
  'ACC-002': require('./ACC-002.png'),
  'ACC-003': require('./ACC-003.png'),
  'ACC-004': require('./ACC-004.png'),
  'ACC-005': require('./ACC-005.png'),
  'ACC-006': require('./ACC-006.png'),
  'AIT-001': require('./AIT-001.png'),
  'COM-001': require('./COM-001.png'),
  'EXP-001': require('./EXP-001.png'),
  'EXP-002': require('./EXP-002.png'),
  'EXP-003': require('./EXP-003.png'),
  'EXP-004': require('./EXP-004.png'),
  'EXP-005': require('./EXP-005.png'),
  'EXP-006': require('./EXP-006.png'),
  'EXP-007': require('./EXP-007.png'),
  'EXP-008': require('./EXP-008.png'),
  'HID-001': require('./HID-001.png'),
  'MAS-001': require('./MAS-001.png'),
  'MAS-002': require('./MAS-002.png'),
  'MAS-003': require('./MAS-003.png'),
  'PER-004': require('./PER-004.png'),
  'QUI-001': require('./QUI-001.png'),
  'QUI-002': require('./QUI-002.png'),
  'QUI-003': require('./QUI-003.png'),
  'QUI-004': require('./QUI-004.png'),
  'QUI-005': require('./QUI-005.png'),
  'QUI-006': require('./QUI-006.png'),
  'QUI-007': require('./QUI-007.png'),
  'SEA-001': require('./SEA-001.png'),
  'SEA-012': require('./SEA-012.png'),
  'SEA-013': require('./SEA-013.png'),
  'STR-001': require('./STR-001.png'),
  'STR-002': require('./STR-002.png'),
  'STR-005': require('./STR-005.png'),
  'SUB-004': require('./SUB-004.png'),
  'SUB-007': require('./SUB-007.png'),
};

/** @returns {any|null} image source for a badge id, or null when not designed yet. */
export function getBadgeImage(id) {
  return BADGE_IMAGES[id] || null;
}

export default BADGE_IMAGES;
